// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.internal-phone-number[data-v-60e35b44] {
  padding-left: 50px;
}
.internal-phone-number[data-v-60e35b44] .contact-number {
  position: relative;
  border-bottom: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
  padding-left: 0px;
}
.internal-phone-number[data-v-60e35b44] .contact-number .input-group .v-text-field__details {
  opacity: 1;
  padding-right: 0px;
}
.internal-phone-number[data-v-60e35b44] .call-number-txt {
  max-width: calc(100% - 50px);
  display: inline-block;
  padding-left: 0;
  width: 100%;
}
.internal-phone-number[data-v-60e35b44] .selectedCountry {
  max-width: 50px;
  display: inline-block;
  position: static;
  padding-left: 0;
  vertical-align: top;
}
.internal-phone-number[data-v-60e35b44] .selectedCountry .input-group__selections {
  display: inline-block;
  position: relative;
  top: 5px;
}
.internal-phone-number[data-v-60e35b44] .v-text-field input,
.internal-phone-number[data-v-60e35b44] .selectedCountry .v-select__slot,
.internal-phone-number[data-v-60e35b44] .validation,
.internal-phone-number[data-v-60e35b44] .contact-number .v-text-field__slot {
  opacity: 1;
}
.show-number .internal-phone-number[data-v-60e35b44] .input-group input,
.show-number .internal-phone-number[data-v-60e35b44] .selectedCountry .v-select__slot,
.show-number .internal-phone-number[data-v-60e35b44] .validation,
.show-number .internal-phone-number[data-v-60e35b44] .contact-number .v-text-field__slot {
  opacity: 1;
}
.internal-phone-number[data-v-60e35b44] .backspace-icon {
  display: none;
}
.internal-phone-number[data-v-60e35b44] .validation {
  position: absolute;
  right: 2px;
  top: 4px;
  z-index: 3;
}
.internal-phone-number[data-v-60e35b44] .validation .v-icon {
  z-index: 999;
  position: relative;
}
.internal-phone-number[data-v-60e35b44] .contact-number .v-text-field label {
  top: 0px;
  left: 2px;
  font-size: 15px;
}
.validation[data-v-60e35b44] {
  position: absolute;
  right: 30px;
  top: 6px;
}
.selectedCountry[data-v-60e35b44] {
  font-size: 16px;
}
.selectedCountry[data-v-60e35b44] .input-group--select__autocomplete {
  max-width: 40px;
}
i.v-icon.material-icons.input-group__append-icon.input-group__icon-cb[data-v-60e35b44] {
  width: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.flag[data-v-60e35b44] {
  display: inline-block;
  width: 16px;
  height: 11px;
  background: url(/img/flags.png) no-repeat;
}
.flag.flag-gb[data-v-60e35b44] {
  background-position: -144px -44px;
}
.flag.flag-ie[data-v-60e35b44] {
  background-position: -48px -66px;
}
.flag.flag-eu[data-v-60e35b44] {
  background-position: -16px -44px;
}
.contact-number[data-v-60e35b44] {
  padding-left: 50px;
  padding-bottom: 5px;
  padding-right: 55px;
}
.contact-number[data-v-60e35b44] .v-input__control .v-input__slot:after,
.contact-number[data-v-60e35b44] .v-input__control .v-input__slot:before {
  opacity: 1;
}
.selectedCountry[data-v-60e35b44] {
  font-size: 15px;
  position: absolute;
  left: 0px;
  padding-left: 8px;
  margin-top: 0px !important;
}
.call-number-txt[data-v-60e35b44] label {
  top: 0px;
}
.selectedCountry[data-v-60e35b44] .v-select__selections {
  color: #b9b9b9 !important;
}
.contact-number[data-v-60e35b44] .v-text-field__slot label {
  top: 5px !important;
  font-size: 14px;
}
.internal-phone-number[data-v-60e35b44] .v-tooltip {
  z-index: 999;
  position: relative;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
